export default __webpack_public_path__ + "4c4316d6b0c3e3fcf62f045a10718793.png";